import React from "react";
import config from "../config";

import {
    Select,
    Button,
    Space,
    DatePicker,
    Row,
    Col,
    Dropdown,
    Checkbox,
    Modal,
    Tooltip,
    message,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";

import { PlusOutlined, DownOutlined, DeleteFilled } from "@ant-design/icons";
import withRouter from "../withRouter";
import ListTable from "./ListTable";
import CompanyAutocomplete from "./CompanyAutocomplete";
import SensorReportStore from "../store/SensorReportStore";

import moment from "moment";

import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import VehicleStore from "../store/VehicleStore";
import AddSensors from "./AddSensors";
import SensorListStore from "../store/SensorListStore";
import { Link } from "react-router-dom";
import DeleteConfirm from "./DeleteConfirm";
import CompanyStore from "../store/CompanyStore";


dayjs.extend(customParseFormat);

const defaultValue = moment().startOf("day").hour(0).minute(0).second(0);
const { Option } = Select;

let widthAdderFunc = (arr) => {
    let array = arr;
    array.map((val) => {
        if (val.title?.length > 24) {
            val.width = 250;
        } else if (val.title?.length > 15) {
            val.width = 200;
        } else if (val.title?.length > 12) {
            val.width = 150;
        } else if (val.title?.length > 8) {
            val.width = 125;
        } else {
            val.width = 110;
        }
        // console.log(val.title.length)
    });

    return arr;
};
class SensorsList extends React.Component {
    constructor(props, context) {
        super(props);
        this.handleTableChange = this.handleTableChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleChange = this.handleChange.bind(this);

        this.sensorReportStore = new SensorReportStore(this);
        this.vehicleStore = new VehicleStore(this);
        this.senesorListStore = new SensorListStore();
        this.companyStore = new CompanyStore(this);



        this.state = {
            loading: false,
            pageSize: 50,
            currentPage: 1,
            company_name: "",
            listUpdated: 0,
            companyId: "",
            fromDate: dayjs().format("YYYY-MM-DD 00:00:00"),
            toDate: dayjs().format("YYYY-MM-DD HH:mm:ss"),
            selectedVehicles: '',
            selectAllVehicles: false,
            modalVisible: false,
            column: "",
            filter: "",
            Notcompany: false,
            Notasset: false,
            sensorId: '',
            company_value_label: "",
            selectedColumns: widthAdderFunc([
                {
                    title: context.translate("_FLEET_DASHBORD_NEWPOI_COMPANY_"),
                    dataIndex: "name",
                    key: "name",
                    width: "15%",
                },
                {
                    // title: "Asset Name",
                    title: context.translate("_FLEET_DASHBORD_VEHICLE_VIEWICON_TITLE_"),
                    dataIndex: "vehicleNo",
                    key: "vehicleNo",
                    width: "15%",
                    render: (val, record) => {
                        return (
                            <Link
                                onClick={(e) => {
                                    e.preventDefault();
                                    this.onEdit(record);
                                }}
                            >
                                {val}
                            </Link>
                        );
                    }
                },
                {
                    // title: "Alarm Type",
                    title: context.translate("_SENSOR_ID_"),
                    dataIndex: "sensorId",
                    key: "sensorId",
                    width: "15%",
                },
                {
                    // title: "Power",
                    title: context.translate("_SENSOR_NAME_"),
                    dataIndex: "sensorName",
                    key: "sensorName",
                    width: "15%",
                },
                {
                    // title: "Battery Voltage",
                    title: context.translate("_TEMP_CALIBRATION_FACTOR_"),
                    dataIndex: "calibrationFactor",
                    key: "calibrationFactor",
                    width: "15%",
                },
                {
                    // title: "Power Voltage",
                    title: context.translate("_HUMIDITY_CALIBRATION_FACTOR_"),
                    dataIndex: "humidityCalFactor",
                    key: "humidityCalFactor",
                    width: "15%",
                }, {
                    title: context.translate("_ACTION_"),
                    dataIndex: "Action",
                    key: "Action",
                    // fixed: 'right',
                    width: "10%",
                    render: (_, record) => {
                        return (
                            <>
                                <Space>
                                    <DeleteConfirm
                                        onConfirm={(e) => {
                                            e.preventDefault();
                                            this.onDelete(record);
                                        }}
                                    >
                                        <Link>
                                            <Tooltip
                                                // title="Delete Maintenance"
                                                title={context.translate("_DELETE_")}
                                                placement="bottom"
                                                color={config.tooltipColorDelete}
                                            >
                                                <DeleteFilled style={{ color: config.deleteColor }} />
                                            </Tooltip>
                                        </Link>
                                    </DeleteConfirm>
                                </Space>
                            </>
                        );
                    },
                }
            ]),
        };

        this.newColumns = [...this.state.selectedColumns];
    }

    onEdit = async (record) => {
        await this.context.viewStateStore.setSensorStates({
            companyId: record.companyId,
        });
        this.setState({ id: record.Id });
        this.setState({ openSensorForm: true });
    };
    onDelete = async (record) => {
        const response = await this.senesorListStore.deleteRecord({
            Id: record.Id, vehicleId: record.vehicleId
        });
        //  console.log(response.data.success)
        if (response?.data?.success === "S") {
            message.success(response.data.message);
            this.handleSearch();
        } else {
            message.error(response.data.message);
        }
    }

    async componentDidMount() {
        if (Number(this.props.getUserData().isadmin) !== -1) {
            console.log(this.props.getUserData().userCompanyId)
            await this.setState({ companyId: this.props.getUserData().userCompanyId })
            await this.setState({ userId: this.props.getUserData().userId })
            await this.vehicleStore.getVehiclesCompanyId(this.props.getUserData().userCompanyId);
            await this.handleSearch();
        }
        this.setState({ pageSize: 50 });

        await this.setState({ column: this.state.selectedColumns });
    }

    async handleTableChange(pagination, filters, sorter) {
        //   console.log(pagination);
        await this.setState({
            currentPage: pagination.current,
            pageSize: pagination.pageSize,
        });
        // this.handleSearch();
        await this.showData();
    }
    onDateTimeChange = (dates) => {
        if (dates) {
            const format = "YYYY-MM-DD HH:mm:ss";
            this.setState({
                fromDate: dates[0].format(format),
                toDate: dates[1].format(format),
            });
        }
    };
    async handleChange(comp) {
        await this.setState({ Notcompany: false });
        await this.setState({
            companyId: comp.value,
            currentPage: 1,
            pageSize: 50,
        });
        const singleData = await this.companyStore.getCompanyDataById(comp.value);
        await this.setState({ company_value_label: singleData });
        await this.setState({ currentPage: 1, companyId: comp?.value });
        await this.setState({ selectedVehicles: '' });
        await this.vehicleStore.getVehiclesCompanyId(comp?.value);
        await this.handleSearch();
        await this.setState({ listUpdated: 1 });
        // this.handleSearch();
    }


    async handleSearch() {
        this.setState({ loading: true });
        console.log("veh", this.state.selectedVehicles)
        const isadmin = Number(this.props.getUserData().isadmin)
        const userId = Number(this.props.getUserData().userId)
        await this.senesorListStore.loadData({
            offset: (this.state.currentPage - 1) * this.state.pageSize,
            limit: this.state.pageSize,
            companyId: this.state.companyId,
            vehicleId: this.state.selectedVehicles,
            Id: -1,
            isadmin: isadmin,
            userId: userId
        });

        await this.setState({ listUpdated: 1 }); //need to reload data
        this.setState({ loading: false });
    }

    showData = async () => {
        if (!this.state.companyId) {
            this.setState({ Notcompany: true });
        } else {
            this.setState({ Notcompany: false });
        }

        if (this.state.companyId) {
            this.setState({ Notcompany: false });
            await this.senesorListStore.loadData({
                offset: (this.state.currentPage - 1) * this.state.pageSize,
                limit: this.state.pageSize,
                companyId: this.state.companyId,
                vehicleId: this.state.selectedVehicles,
                fromDate: this.state.fromDate,
                toDate: defaultValue.format("YYYY-MM-DD HH:mm:ss"),
                pageNo: this.state.currentPage
            });
            // console.log(this.state.fromDate,this.state.toDate,)
            await this.setState({ listUpdated: 1 });
        }
    };
    handleAllSelectVehicles = async (e) => {
        if (this.state.selectAllVehicles) {
            const allVehicles = this.vehicleStore?.getVehiclesUsingCompanyId.map(
                (val) => {
                    return val.vehicleId;
                }
            );
            await this.setState({ selectedVehicles: allVehicles });
        } else {
            await this.setState({ selectedVehicles: [] });
        }
    };

    handleCheckboxChange = async (column) => {
        console.log(column);
        if (this.state.selectedColumns.some((c) => c.key === column.key)) {
            const filtered = this.state.selectedColumns.filter(
                (c) => c.key !== column.key
            );
            console.log(filtered);
            await this.setState({
                selectedColumns: filtered,
            });
            await this.setState({ column: filtered });
            // await  this.updateVisibleColumns();
        } else {
            console.log("adsf");
            await this.setState({
                selectedColumns: [...this.state.selectedColumns, column],
                column: [...this.state.selectedColumns, column],
            });
            // await  this.updateVisibleColumns();
        }
    };
    closeModal = () => {
        this.setState({
            openSensorForm: false,
            id: "",
        });
    };
    responseMsg = async (resp) => {
        if (resp.data.success == "S") {
            message.success(resp.data.message);
            this.setState({ openSensorForm: false });
            this.setState({ listDataUpdate: true });
        } else if (resp.data.success == "F0") {
            resp.data.errors.map((value) => {
                message.error(resp.data.message);
            });
        }

    };
    async componentDidUpdate(prevProps, prevState) {
        if (prevState.listDataUpdate !== this.state.listDataUpdate) {
            const beforeEditCompanyId =
                this.context.viewStateStore.sensorObject.companyId;
            await this.senesorListStore.loadData({
                offset: (this.state.currentPage - 1) * this.state.pageSize,
                limit: this.state.pageSize,
                companyId: this.context.viewStateStore.sensorObject.companyId,
            });

            const singleData = await this.companyStore.getCompanyDataById(
                this.context.viewStateStore.sensorObject.companyId
            );
            await this.setState({ listUpdated: 1 }); //need to reload data
            await this.setState({
                company_value_label: singleData,
                companyId: beforeEditCompanyId,
            });

            this.setState({ listDataUpdate: false });
        }
    }
    render() {
        return (
            <>
                <div style={{ padding: 0 }}>
                    <Row className="headerFixed" style={{ height: "50px" }}>
                        <Col span={12}>
                            <div className="heading">
                                {this.context.translate("_SENSOR_LIST_")}
                            </div>
                        </Col>
                        <Col
                            span={12}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "end",
                            }}
                        >
                            <Space
                                style={{
                                    float:
                                        this.context.locale.direction == "ltr" ? "right" : "left",
                                }}
                            >
                                <Tooltip
                                    placement="left"
                                    // title="Add"
                                    title={this.context.translate("_FLEET_ROLE_ROLELIST_ADDBTN_")}
                                    color={config.primaryColor}
                                >
                                    <Button
                                        className="addButton"
                                        icon={<PlusOutlined />}
                                        type="primary"
                                        onClick={() =>
                                            this.setState({ openSensorForm: true, id: "" })
                                        }
                                    ></Button>
                                </Tooltip>


                                <Button onClick={() => this.setState({ modalVisible: true })}>
                                    {/* Columns */}
                                    {this.context.translate("_COLUMNS_")}
                                </Button>
                            </Space>
                        </Col>
                    </Row>
                </div>
                <div
                    style={{
                        paddingTop: "10px",
                        paddingRight: "24px",
                        paddingLeft: "24px",
                    }}
                >
                    <Row className="listInputRow">
                        <Space>
                            <Col span={16}>
                                <CompanyAutocomplete
                                    onChange={(value) => this.handleChange(value)}
                                    value={
                                        this.state.company_value_label
                                            ? this.state.company_value_label
                                            : null
                                    }
                                    allowClear={true}
                                    style={{ width: 150 }}
                                    status={this.state.Notcompany ? "error" : false}
                                />
                            </Col>

                            <Col>

                                <Select
                                    value={
                                        this.state.selectedVehicles
                                            ? this.state.selectedVehicles
                                            : null
                                    }
                                    onChange={async (val) => {
                                        await this.setState({ selectedVehicles: val });
                                        await this.handleSearch()
                                    }}
                                    style={{ width: 150 }}
                                    showSearch
                                    status={this.state.Notasset ? "error" : false}
                                    placeholder={this.context.translate(
                                        "_FLEET_DASHBORD_VEHICLE_VIEWICON_TITLE_"
                                    )}
                                    filterOption={(inputValue, option) => {
                                        if (option.children) {
                                            return (
                                                option.children
                                                    .toLowerCase()
                                                    .indexOf(inputValue.toLowerCase()) >= 0
                                            );
                                        }
                                    }}
                                >
                                    {this.vehicleStore?.getVehiclesUsingCompanyId?.map((val) => {
                                        return (
                                            <Option value={val.vehicleId}>{val.vehicleNo}</Option>
                                        );
                                    })}
                                </Select>
                            </Col>


                            <Col>
                                <Button
                                    type="primary"
                                    onClick={async () => {
                                        await this.setState({ currentPage: 1, pageSize: 50 });
                                        await this.showData();
                                    }}
                                >
                                    {/* Show */}
                                    {this.context.translate("_FLEET_SHOW_BTN_")}
                                </Button>
                            </Col>
                        </Space>
                    </Row>

                    <Modal
                        open={this.state.modalVisible}
                        width={300}
                        // title="Select Columns"
                        title={this.context.translate("_SELECT_COLUMNS_")}
                        onCancel={() => this.setState({ modalVisible: false })}
                        onOk={() => {
                            this.setState({ modalVisible: false });
                        }}
                        footer={null}
                    >
                        <div style={{ maxHeight: "400px", overflowY: "auto" }}>

                            {this.newColumns.map((column, v) => {
                                return (
                                    <Row key={v}>
                                        <Col>
                                            <Checkbox
                                                onChange={() => this.handleCheckboxChange(column)}
                                                checked={this.state.selectedColumns.some(
                                                    (c) => c.key === column.key
                                                )}
                                            >
                                                {column.title}
                                            </Checkbox>
                                        </Col>
                                    </Row>
                                );
                            })}
                        </div>
                    </Modal>

                    <ListTable
                        currentPage={this.state.currentPage}
                        pageSize={this.state.pageSize}
                        total={this.senesorListStore?.total}
                        columns={this.state.column}
                        dataSource={this.senesorListStore?.sensorsdata}
                        loading={this.senesorListStore?.loading}
                        onChange={this.handleTableChange}
                        scroll={{
                            // y: this.state.clientHeight-240,
                            x: 100,
                        }}
                    />
                    {this.state.openSensorForm && (
                        <Modal
                            bodyStyle={{
                                // padding: "16px",
                                maxHeight: "80vh",
                                overflow: "auto",
                            }}
                            className="formShowModal"
                            title={this.context.translate("_ADD_SENSOR_DETAILS_")}
                            centered
                            visible={this.state.openSensorForm}
                            footer={null}
                            onCancel={() => {
                                this.setState({ openSensorForm: false, id: "" });
                            }}
                            width={1000}
                        >
                            <div>
                                <AddSensors
                                    id={this.state.id}
                                    companyId={this.state.companyId}
                                    response={this.responseMsg}
                                    closeModal={this.closeModal}
                                />
                            </div>
                        </Modal>
                    )}
                </div>
            </>
        );
    }
}
SensorsList.contextType = StoreContext;
export default observer(withRouter(SensorsList));
